import angular from 'angular'
import ggsUtils from '../utils'

export default angular
  .module('ggs.element-position', [
    ggsUtils
  ])
  .name
